export const LOADING_CUSTOMERS = "LOADING_CUSTOMERS";
export const GET_CUSTOMERS_LIST = "GET_CUSTOMERS_LIST";
export const REMOVE_CUSTOMERS = "REMOVE_CUSTOMERS";
export const ADD_CUSTOMERS = "ADD_CUSTOMERS";
export const UPDATE_CUSTOMERS = "UPDATE_CUSTOMERS";
export const GET_CUSTOMERSBYID = "GET_CUSTOMERSBYID";
export const GET_ORDERSBYID = "GET_ORDERSBYID";
export const GET_QUOTATIONSBYID = "GET_QUOTATIONSBYID";
export const GET_SERVICEREQUESTSBYID = "GET_SERVICEREQUESTSBYID";
export const GET_SERVICEREQUESTSBYREFERENCENO = "GET_SERVICEREQUESTSBYREFERENCENO";
export const GET_INVOICESBYID = "GET_INVOICESBYID";
export const LOADING_ORDERS = "LOADING_ORDERS";
export const LOADING_QUOTATIONS = "LOADING_QUOTATIONS";
export const LOADING_SERVICEREQUESTS = "LOADING_SERVICEREQUESTS";
export const LOADING_INVOICES = "LOADING_INVOICES";
export const GET_CUSTOMER_OPPORTUNITY = "GET_CUSTOMER_OPPORTUNITY";
export const GET_COMPLAINTBYCUSTOMERS = "GET_COMPLAINTBYCUSTOMERS";
export const GET_CUSTOMER_PROFILE_DETAIL = "GET_CUSTOMER_PROFILE_DETAIL";
export const ADD_SOURCE = "ADD_SOURCE";
export const GET_DETAILS_LIST = "GET_DETAILS_LIST";
export const REMOVE_DETAIL = "REMOVE_DETAIL";